import React, { useState, useEffect } from 'react';
import clazz from 'classnames';
import { bodyScroll } from '@/shared/utils';
// import { homeConfig } from '@/shared/PageConfig';
import { getHomeConfig } from '@/shared/PageConfig';
import createElement from '@/shared/createElement';
import LoadingWrapper from '@/components/LoadingWrapper';
// import { mockData } from '@/shared/mock';
import { getMainPage } from '@/services/request';
import './index.less';
export default function Index() {
    const [fetched, setFetched] = useState(false);
    const [state, setState] = useState({});
    useEffect(() => {
        bodyScroll.can();
        getMainPage({}).then((data) => {
            setState(data);
            setFetched(true);
        });
    }, []);
    return (<LoadingWrapper loading={!fetched}>
      <div className={clazz('home-container')}>
        
        {fetched && createElement(getHomeConfig(state), state)}
      </div>
    </LoadingWrapper>);
}
